import { Row, Form, Col, Input, Button, Spin } from "antd";
import Styles from './Styles.module.css'
import { useContext, useState } from "react";
import InputMask from 'react-input-mask'
import { LoadingOutlined } from "@ant-design/icons/lib/icons";
import { setUserDataPreference } from "../../services/Api";
import { UserDataPreferenceContext } from ".";
const inputClassName = `ant-input-affix-wrapper input-text ${Styles.inputText}`

export default function UserDataPreferenceForm({
  enableEmail = false,
  successMessage,
  dataType,
  status,
}) {
    const { setResultMessage } = useContext(UserDataPreferenceContext)
    const [info, setInfo] = useState({firstName: "", lastName: "", phoneNumber: "", email: null, dataType, status})
    const [isLoading, setIsLoading] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)

    const handleKeyDown = event => {
      if (event.key === 'Enter' && !isFormValid()) {
        handleSubmit()
      }
    }

    const handleInputChange = (fieldName, value) => {
      setInfo(prev => {
        const updated = {...prev,
          [fieldName]: value
        }
        validateForm(updated)
        return updated
      })
    }

    const handleSubmit = async () => {
      if(isLoading)
        return
      setIsLoading(true)
      
      const resp = await setUserDataPreference(info)

      setResultMessage(successMessage)
    }

    const validateForm = ({firstName, lastName, phoneNumber, email}) => {
      const firstNameValid = firstName.length != 0;
      const lastNameValid = lastName.length != 0;
      const phoneNumberValid = !phoneNumber.includes("_") && phoneNumber.length != 0;
      const emailValid = enableEmail ? !!email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) : true;
      const isValid = firstNameValid && lastNameValid && phoneNumberValid && emailValid;
      setIsFormValid(isValid)
    } 

    return (
      <>
        <Row>
          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
            <Form.Item style={{marginBottom: "14px"}}>
              <Input
                autoComplete="off"
                className={inputClassName}
                placeholder="First Name*"
                onChange={e => handleInputChange("firstName", e.target.value)}
                onKeyDown={handleKeyDown}
                value={info.firstName}
              />
            </Form.Item>
          </Col>
          <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
            <Form.Item style={{marginBottom: "14px"}}>
              <Input
                autoComplete="off"
                className={inputClassName}
                placeholder="Last Name*"
                onChange={e => handleInputChange("lastName", e.target.value)}
                onKeyDown={handleKeyDown}
                value={info.lastName}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xl={{ span: 8 }} xs={{ span: 24 }}>
            <Form.Item style={{marginBottom: "14px"}}>
              <span className={inputClassName}>
                <InputMask
                  autoComplete="off"
                  className="ant-input"
                  mask="(999) 999-9999"
                  onChange={e => handleInputChange("phoneNumber", e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Phone Number*"
                  value={info.phoneNumber}
                />
              </span>
            </Form.Item>
          </Col>
          {enableEmail && 
            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
              <Form.Item style={{marginBottom: "14px"}}>
                <Input
                  autoComplete="off"
                  className={inputClassName}
                  placeholder="Email*"
                  onChange={e => handleInputChange("email", e.target.value)}
                  onKeyDown={handleKeyDown}
                  value={info.email}
                />
              </Form.Item>
            </Col>
          }
        </Row>
        <Row style={{margin: "2rem"}}>
          <Col xl={{ span: 16 }} xs={{ span: 24 }} className={Styles.alignCenter}>
            <Button
              className={Styles.submitButton}
              disabled={!isFormValid}
              onClick={() => handleSubmit()}
            >
              SUBMIT
            </Button>
            {isLoading && <Spin indicator={<LoadingOutlined spin style={{ fontSize: 24 }} />} style={{ marginLeft: 24 }} />}
          </Col>
        </Row>
      </>
    )
  }